import React from 'react'
import { Box } from '@chakra-ui/react'

export const Divider = (): JSX.Element => (
  <Box
    borderTop="1px solid"
    borderTopColor="green.a50"
    marginBottom="18px"
    width="calc(100% + 36px)"
    marginLeft="-18px"
  />
)
